import * as React from 'react';
import ReactHtmlParser from 'react-html-parser';
import { connect } from 'react-redux';
import * as $ from 'jquery';
import { Redirect } from 'react-router-dom';
import fetch from 'cross-fetch';
import * as uuid from 'uuid';

import { Slug } from '@fnv-core/utils';
import { Logger } from '@fnv-core/logging';
import { Tokenizer } from '@fnv-core/tokens';
import { ProcesHandlerHelpers, ProcesName } from './helpers/ProcesHandlerHelpers';
import * as Templates from '../presentational/Templates';
import { FormController } from '../controllers/FormController';
import * as actions from '../actions/FormActions';
import * as stepActions from '../actions/StepsActions';
import * as extraStepActions from '../actions/ExtraStepsActions';
import { DefaultValueByConditionHelper } from '../helpers/DefaultValueByConditionHelper';
import { PopupError } from '../presentational/PopupError';
import { PopupOk } from '../presentational/PopupOk';
import { ReactFormHelpers } from './helpers/FormHelpers';
import { IFormConfig } from '../interfaces/FormConfig';
import * as userActions from '../actions/UserActions';
import { MijnFNVPageContext } from '../presentational/pages/helpers/MijnFNVPageContext';
import { MenuHelpers } from '../presentational/pages/helpers/MenuHelpers';
import { ErrorMessageService } from '../services/ErrorMessageService';
import { FormService } from '../services/FormService';
import { AnimationService } from '../services/AnimationService';
import { HistoryService } from '../services/HistoryService';
import { AlertMessage } from '../presentational/AlertMessage';
import {
    storeLidZoeken,
    clearLidZoeken,
    startLidZoeken,
    stopLidZoeken,
    passthroughLidZoeken
} from '../actions/LidZoekenActions';
import { PageHelpers } from '../presentational/pages/helpers/PageHelpers';
import { StringHelpers } from '../helpers/StringHelpers';
import { InitialFormValuesHandlerHelper } from './helpers/InitialFormValuesHandlerHelper';
import { DatasourceLoaderStateService } from '../services/DatasourceLoaderStateService';
import { getResourceString } from '../kentico/resource-strings';

import { createUpdateSavedQuerystringParameters } from '../../helpers/sessionstorage-helpers';
import { getAllUrlParams } from '../../jslibs/urlparams';
import { CookieManager } from '@fnv-core/cookies';

const uuidV4 = uuid.v4;

export interface FormProps {
    editMode?: boolean;
    formConfig: IFormConfig;
    formDefinitions: any;
    setFormValues: any;
    clearFormValues: (formName: string) => void;
    fillFormViaApi: any;
    clearErrorOnApiError: any;
    forms: any;
    steps: any;
    additionalCssClass: string;
    withLinkToFormPage?: boolean;
    formName?: string; // this is the kenticoformname
    pageType: string;
    setActiveStepForm: any;
    clearStep: any;
    clearExtraStep: any;
    storeStep: any;
    storeExtraStep: any;
    nextLink: string;
    linkText: string;
    userId: string;
    roles: any[];
    summaryIntro: string;
    onSuccessPopupMessage?: string;
    onSuccessPopupMessageVisualCheck?: string;
    onSuccessPopupDescription?: string;
    clearFormErrorMessage: any;
    storeFormErrorMessage: any;
    layoutType: string;

    lidZoeken: any;

    storeLidZoeken: any;
    clearLidZoeken: any;
    startLidZoeken: any;
    stopLidZoeken: any;

    initialData?: any;

    onSubmitSuccessButton1Link : string;
    onSubmitSuccessButton1LinkText : string;

    onSubmitSuccessButton2Link : string;
    onSubmitSuccessButton2LinkText : string;

    includeCurrentPageAsBackAndSubmitUrl? : boolean;
    backTitleForCurrentPageBackLink? : string;

    onOverrideGetFormValues?: any;

    errorMessageTitle? : string;
    errorMessageDescription? : string;
    errorMessagePhoneNumberInfo? : string;
    errorMessagePhoneNumber? : string;
    errorMessageEmailInfo? : string;
    errorMessageEmail? : string;
    errorMessageButtonText? : string;

    setFieldError? : (formControlName: string, errorText : string) => void;
    onFieldChange? : (formName: string, fieldName : string, value : any) => void;
    passthroughLidZoeken: (fieldName: string, value: any) => void;
    onPopupOkClick? : () => Promise<any>;
}

export interface FormState {
    currentForm: string;
    initialFormValues: any;
    stepIndex: number;
    urlParams: any;
    redirectToUrl: string;
    showPopupConfirm: boolean;
    popupMessageOnFailure?: string;
    showPopupOK: boolean;
    isShowPostOKWithVisualCheck: boolean;
    isSubmitting: boolean;
    isShowPostDataError: boolean;
    isShowPostOk: boolean;
    isShowTooBigDataError: boolean;
    isUserError: boolean;
    showThanksMessageAsInPageContent: boolean;
    refreshId: string;
    isShowPollResults : boolean;
    pollResults: any;
}

const mapStateToProps = (state: any) => {
    return {
        forms: state.forms,
        userId: state.user.userId,
        roles: state.user.roles,
        lidZoeken: state.lidZoeken,
        steps: state.steps
    };
};

const mapDispatchToProps = (dispatch: any) => {
    return {
        setFormValues: (formName: string, values: any) => {
            dispatch(actions.storeFormValues(formName, values));
        },
        clearFormValues: (formName: string) => {
            dispatch(actions.clearFormValues(formName));
        },
        fillFormViaApi: (formName: string, userId: string, url: string, formDefinitions: any[], pathParam : string, formSteps : string[], formConfig, kenticoFormName: string) => {
            let idInUrl = userId;
            if (pathParam) {
                idInUrl = pathParam;
            }
            let fillFormViaApiUrl = Tokenizer.replaceTokens(url, [idInUrl]);
            let queryParameters = getAllUrlParams(location.href);
            const tokens = [
              { name: 'formname', value: kenticoFormName },
              { name: 'path-param', value: pathParam },
            ];
            fillFormViaApiUrl = Tokenizer.replaceTokens(fillFormViaApiUrl, tokens).toLowerCase();
            fillFormViaApiUrl = StringHelpers.replacePropertiesInUrl(fillFormViaApiUrl, queryParameters, true);

            let addQueryParameterSeparator = "?";
            if (fillFormViaApiUrl.indexOf("?") >= 0) {
                addQueryParameterSeparator = "&";
            }
            if (queryParameters["KenticoWordLidId"]) {
                fillFormViaApiUrl = `${fillFormViaApiUrl}${addQueryParameterSeparator}KenticoWordLidId=${queryParameters["KenticoWordLidId"]}`;
            }
            dispatch(actions.fillFormViaApi(formName, fillFormViaApiUrl, formDefinitions, formSteps, formConfig));
        },
        clearErrorOnApiError: () => {
            dispatch(actions.clearErrorOnApiError());
        },
        setActiveStepForm: (stepFormName: string) => {
            dispatch(stepActions.setActiveStepForm(stepFormName));
        },
        clearStep: () => {
            dispatch(stepActions.clearStep());
        },
        clearExtraStep: () => {
            dispatch(extraStepActions.clearStep());
        },
        storeStep: (title: string, formName: string) => {
            dispatch(stepActions.storeStep(title, formName));
        },
        storeExtraStep: (title: string) => {
            dispatch(extraStepActions.storeStep(title));
        },
        storeFormErrorMessage: (formName: string, errorMessage: string) => {
            dispatch(actions.storeFormErrorMessage(formName, errorMessage));
        },
        clearFormErrorMessage: (formName: string) => {
            dispatch(actions.clearFormErrorMessage(formName));
        },
        loginAction: (email, lidnummer, name, accessToken, userId, roles) =>
            dispatch(
                userActions.storeUser(email, lidnummer, name, accessToken, '-', '-', userId, roles)
            ),

        storeLidZoeken: (data, lidnummer, postcode, huisnummer, geboortedatum, zoekenOp, searchValue, formName, additionalData) => dispatch(
            storeLidZoeken(data, lidnummer, postcode, huisnummer, geboortedatum, zoekenOp, searchValue, formName, additionalData)),

        clearLidZoeken: () => dispatch(clearLidZoeken()),
        startLidZoeken: () => dispatch(startLidZoeken()),
        stopLidZoeken: () => dispatch(stopLidZoeken()),
        passthroughLidZoeken: (fieldName : string, value : any) => {
            dispatch(passthroughLidZoeken(fieldName, value));
        }
    };
};

export class FormControllerContainer extends React.Component<FormProps, FormState> {
    formControllerRef = React.createRef<FormController>();
    public unmounted: boolean = true;
    constructor(props: FormProps) {
        super(props);

        this.state = {
            currentForm: props.formConfig.startForm,
            stepIndex: props.formConfig.formSteps.indexOf(props.formConfig.startForm),
            urlParams: getAllUrlParams(),
            redirectToUrl: '',
            showPopupConfirm: false,
            showPopupOK: false,
            isShowPostOKWithVisualCheck: false,
            isSubmitting: false,
            isShowPostDataError: false,
            isShowPostOk: false,
            isUserError: false,
            initialFormValues: {},
            showThanksMessageAsInPageContent: false,
            isShowTooBigDataError: false,
            refreshId: "",
            isShowPollResults: false,
            pollResults: {}
        };

        this.onSubmit = this.onSubmit.bind(this);
        this.onSummaryBackToStepClick = this.onSummaryBackToStepClick.bind(this);
        this.onGotoPreviousStep = this.onGotoPreviousStep.bind(this);
        this.scrollToForm = this.scrollToForm.bind(this);
        this.setFieldError = this.setFieldError.bind(this);
        this.onPostToBackend = this.onPostToBackend.bind(this);
        this.onPopupConfirmOK = this.onPopupConfirmOK.bind(this);
        this.onPopupConfirmCancel = this.onPopupConfirmCancel.bind(this);
        this.onPopupOKSubmit = this.onPopupOKSubmit.bind(this);
        this.thankYouMessageRef = React.createRef();

        FormService.setPayload({});
        AnimationService.resetPreloadForm(this.state.currentForm);
    }

    wasOnSummaryStep : boolean = false;
    visitedSteps: any = {};
    thankYouMessageRef : any;

    componentDidMount() {
        // Activate form, execute given handlers
        // ReactFormHelpers.activateForm(this).then(component => {});        
        if (this.props.formConfig.fillViaApi !== undefined && this.props.formConfig.fillViaApi !== "") {
            AnimationService.startPreloadForm(this.state.currentForm);
        }
        //PBI 25634 - need to persist querystring parameters in URLS between different forms
        if (this.props.formConfig.usePersistedQueryString === true) {
            createUpdateSavedQuerystringParameters(window.location.href);
        }
    
        ReactFormHelpers.clearFormIfAllowed(this);
        ReactFormHelpers.activateFormController(this);
        this.unmounted = false;
        ReactFormHelpers.activateForm(this);

        if (this.context && this.context.search) {
            let urlParams = getAllUrlParams(this.context.search);
            if (urlParams.action == 'tosummary') {
                ReactFormHelpers.gotoFormStepNyName(this, '_summary');
            }
        }

        this.setupOptionalBreadcrumbParent();

        FormService.setIsInLidZoekenSubFunctions(false);
        FormService.setLidZoekenSubFunctionsForMember({});

        if (!ReactFormHelpers.hasLidConsentForSpecificFormsOrIgnoreIfIsCurrentUser(this)) {
            
            const backUrl = FormService.getBackUrl();
            if (backUrl && backUrl != "") { 
                this.setState({
                    redirectToUrl: backUrl
                });
            } else {
                location.href = "/404";
            }
        }

        if (this.props.formConfig.leavePageProtection) {
            
            const promptLeaveMessage = getResourceString("Form.Save.Warning");
            if (!this.wasSetupBeforeUnload) {
                this.wasSetupBeforeUnload = true;
                $(window).off('beforeunload');
                $(window).on('beforeunload', () => {
                    if (this.state.isSubmitting ||
                        this.props.formConfig.formSteps.length == 1 ||
                        this.state.stepIndex == this.props.formConfig.formSteps.length - 1) {
                        return undefined;
                    }            
                    return promptLeaveMessage;
                });
            }
        }

        if (!!this.props.formConfig.userHasVoted && !!this.props.formConfig.isPoll) {
            this.onShowPollResults();
        }
        
    }

    componentDidUpdate(prevProps) {
        
        if (prevProps.forms["_formSubmitTrigger"] && 
            this.props.forms["_formSubmitTrigger"] &&
            this.props.forms["_formSubmitTrigger"].autoPost !== prevProps.forms["_formSubmitTrigger"].autoPost) 
        {
            if (this.props.forms["_formSubmitTrigger"] && 
                this.props.forms["_formSubmitTrigger"].autoPost === true) {
                    this.onStoreValues(this.getInitialFormValues());

                    this.props.setFormValues("_formSubmitTrigger", 
                        {
                            afterStoreValues: true,
                            autoPost: true
                        });
            }
        } 

        if (prevProps.forms["_formSubmitTrigger"] && 
            this.props.forms["_formSubmitTrigger"] &&            
            this.props.forms["_formSubmitTrigger"].afterStoreValues !== prevProps.forms["_formSubmitTrigger"].afterStoreValues) 
        {
            if (this.props.forms["_formSubmitTrigger"] &&
                this.props.forms["_formSubmitTrigger"].autoPost === true && 
                this.props.forms["_formSubmitTrigger"].afterStoreValues === true) {

                this.props.setFormValues("_formSubmitTrigger", 
                    {
                        autoPost: false,
                        afterStoreValues: false
                    });      
                ReactFormHelpers.gotoNextFormStep(this, this.getInitialFormValues());                                          
            }
        }

        if (prevProps.forms !== this.props.forms) {
            // see renderController method for details regarding this construct
            this.setState({refreshId : uuidV4()});
        } 
      }

    wasSetupBeforeUnload = false;

    componentWillUnmount() {
        this.unmounted = true;
    }

    setupOptionalBreadcrumbParent() {

        // TODO : formconfig via interface ipv cast naar any
        if (!!(this.props.formConfig as any).showEditPaginaBreadCrumbs) {
            MenuHelpers.showBreadCrumbsEditPage();
        }

        if ((this.props.formConfig as any).insertBreadCrumbParentLink &&
            (this.props.formConfig as any).insertBreadCrumbParentText) {
            MenuHelpers.addBreadCrumbsParent(
                (this.props.formConfig as any).insertBreadCrumbParentLink,
                (this.props.formConfig as any).insertBreadCrumbParentText
            );
        }
    }

    setFieldError(formControlName: string, errorText: string) {
      var foundControl = this.props.formDefinitions.Form.find((control) => { return control.name == formControlName});
      if(foundControl) {
        foundControl.validation.post = { 
          error: errorText,
          value: this.props.forms.Form[formControlName]
        };
        if (this.formControllerRef.current) {
          this.formControllerRef.current.revalidateForm();
        }
      }
    }

    scrollToForm() {
        if (!!this.props.formConfig.noScrollToTop) {
            return;
        }
        if (this.state.stepIndex > 0) {        
            window.scrollTo(0, $('.react-container').offset().top);
        } else {
            // workaround via jquery to prevent scrolling issue on mobile
            // (on mobile the page scrolls to the middle of the page when window.scrollTo(0,0) is used)
            $('html, body').animate({
                scrollTop: '0px'
            });        
        }
    }

    onPostToBackend(values: any[], includeCurrentValues? : boolean) {        
        // write a simple cookie containing the form name
        if(this.state.currentForm != undefined && this.state.redirectToUrl != null){
          CookieManager.createCookie("submitted-form", this.state.currentForm, 1);
        }
        
        ReactFormHelpers.postToBackendPopup(this, values, includeCurrentValues)
            .then(() => {
                // dummy handler which is needed to prevent js errors, this is handled in postToBackendPopup itself
            })
            .catch(() => {
                // same as above
            });
    }

    onStoreValues = (values: any, formName? : string) => {
        if (formName !== undefined) {
            this.props.setFormValues(formName, values);
            return;
        }
        let valuesToStore = (Object as any).assign(
            {},
            values,
            { pageIsValidated: true },
            ReactFormHelpers.getFormValuesToStore(this, values)
        );

        ReactFormHelpers.setFormValues(this, valuesToStore);

        return valuesToStore;
    }

    onSubmit(values: any, includeCurrentValues? : boolean, onlySaveForm? : boolean) {
        
        if (DatasourceLoaderStateService.getLoadingCounter() > 0) {
            return;
        }
      
        $(window).off('beforeunload');

        AnimationService.disableAnimationsForForm(this.state.currentForm);

        if (this.state.currentForm && 
            this.visitedSteps && 
            !this.visitedSteps[this.state.currentForm]) {
            this.visitedSteps[this.state.currentForm] = true;
        }
        
        this.onStoreValues(values);        
        ReactFormHelpers.gotoNextFormStep(this, values, !!includeCurrentValues, !!onlySaveForm);
    }

    onGotoPreviousStep(values: any) {
        ReactFormHelpers.gotoPreviousStep(this, values || {});
    }

    onPopupConfirmOK(event: React.MouseEvent) {
        event.preventDefault();

        this.setState({ showPopupConfirm: false, showPopupOK: true });

        //this.onPostToBackend();

        return false;
    }

    onPopupConfirmCancel(event: React.MouseEvent) {
        event.preventDefault();

        this.setState({ showPopupConfirm: false, isSubmitting: false });

        return false;
    }

    redirectToUrl = (url : string) => {
        this.setState({
            redirectToUrl: url
        });
    }

    onCancelForm = () => {
        let handlers = this.props.formConfig.handlers;
                    
        if (!handlers) {
            handlers = ProcesHandlerHelpers.getProcessesForHander(this.props.formConfig.procesHandlers);
        }

        const CancelForm = ProcesName.CancelForm;
        const handleProces = ProcesHandlerHelpers.handleProces;
        handleProces(handlers, CancelForm, this, "").then(data => {
            if (data && !!data.isPreventDefault) {
                return;
            }
            if (this.unmounted)  {
                return;
            }
            this.setState({
                showPopupConfirm: false,
                showPopupOK: false,
                isShowPostOKWithVisualCheck: false,
                isShowPostOk: false,
                popupMessageOnFailure: undefined
            });
        });
    }

    onPopupOKSubmit(event: React.MouseEvent, reactRouteOnSuccess) {
        if (event) {
            event.preventDefault();
        }

        let handlers = this.props.formConfig.handlers;
        if (!handlers) {
            handlers = ProcesHandlerHelpers.getProcessesForHander(this.props.formConfig.procesHandlers);
        }

        const PopupOnOk = ProcesName.PopupOnOk;
        const handleProces = ProcesHandlerHelpers.handleProces;
        handleProces(handlers, PopupOnOk, this, reactRouteOnSuccess).then(data => {
            if (data && !!data.isPreventDefault) {
                return;
            }
            if (this.unmounted)  {
                return;
            }
            if (this.context && this.context.search) {
                let urlParams = getAllUrlParams(this.context.search);
                if (urlParams.gobackUrl) {
                    if (!(this as any).unmounted) {
                        this.setState({
                            redirectToUrl: urlParams.gobackUrl,
                            showPopupConfirm: false,
                            showPopupOK: false,
                            isShowPostOKWithVisualCheck: false,
                            isShowPostOk: false,
                            isUserError: false,
                            popupMessageOnFailure: undefined
                        });
                        return;
                    }
                }
            }

            let redirectToUrl = undefined;
            if (this.props.formConfig.reactRouteOnSuccess && 
                this.props.formConfig.reactRouteOnSuccess !== "") {
                if (!(this as any).unmounted) {
                    
                    let redirectUrl = StringHelpers.replacePropertiesInUrl(reactRouteOnSuccess || this.props.formConfig.reactRouteOnSuccess || '/', 
                        {...this.getPayload(),
                        pathParam: this.context.pathParam
                        });

                    if (this.props.formConfig.OnSubmitSuccessLinkIncludeUrlGuid && this.context.pathParam) {
                        redirectUrl += "/" + this.context.pathParam;
                    }

                    redirectToUrl =  PageHelpers.getMijnFNVRootPathForRole(
                        redirectUrl
                    );

                    AnimationService.disableAnimationsForForm(this.state.currentForm);
                    const history = HistoryService.getRouterHistory();
                    if (history) {
                        history.push(redirectToUrl);
                        return;
                    }
                }                
            }
            
            this.setState({
                showPopupConfirm: false,
                showPopupOK: false,
                isShowPostOKWithVisualCheck: false,
                isShowPostOk: false,
                isUserError: false,
                popupMessageOnFailure: undefined
            });

            ReactFormHelpers.clearFormIfAllowed(this);

            if (this.context && this.context.search) {
                let urlParams = getAllUrlParams(this.context.search);
                if (urlParams.onsuccess) {
                    if (!(this as any).unmounted) {
                        this.setState({
                            redirectToUrl: urlParams.onsuccess + '?action=' + urlParams.onsuccessaction
                        });
                        return;
                    }
                }            
            }

            if (this.props.formConfig.reactRouteOnSuccess && 
                this.props.formConfig.reactRouteOnSuccess !== "") {
                if (!(this as any).unmounted) {
                    
                    let redirectUrl = StringHelpers.replacePropertiesInUrl(reactRouteOnSuccess || this.props.formConfig.reactRouteOnSuccess || '/', 
                        {...this.getPayload(),
                        pathParam: this.context.pathParam
                        });

                    if (this.props.formConfig.OnSubmitSuccessLinkIncludeUrlGuid && this.context.pathParam) {
                        redirectUrl += "/" + this.context.pathParam;
                    }

                    this.setState({
                        redirectToUrl: PageHelpers.getMijnFNVRootPathForRole(
                            redirectUrl
                        )
                    });
                }
            } else {
                const { addToUrl, postDataToBackend } = ReactFormHelpers.addToUrl(this);
                location.href = this.props.formConfig.thanksPageUrl + addToUrl;
            }
        });
        
        return false;
    }

    onSummaryBackToStepClick(formName: string, event: any) {
        if (typeof event != 'undefined' && typeof event.preventDefault != 'undefined') {
            event.preventDefault();
        }
        
        this.setState(
            {
                stepIndex: this.props.formConfig.formSteps.indexOf(formName),
                currentForm: formName
            },
            () => {
                this.scrollToForm();
            }
        );

        return false;
    }

    onOverrideGetFormValues = () => {

        if (this.props.formConfig.initialFormValuesHandler) {
            const initialFormValuesHandler = InitialFormValuesHandlerHelper.getHandler(this.props.formConfig.initialFormValuesHandler);
            if (initialFormValuesHandler) {
                return initialFormValuesHandler;
            }
        }
        if (this.props.onOverrideGetFormValues) {
            return this.props.onOverrideGetFormValues();
        }
        return {};
    }

    filterFormValuesWithNullAsValue = (formValues) => {
        const result = {};
        for (const formField in formValues) {
            if (formValues.hasOwnProperty(formField)) {
                if (formValues[formField] != null) {
                    result[formField] = formValues[formField];
                }
            }
        }
        return result;
    }

    getInitialFormValues = () => {
        let urlParams = {};
        if (this.context && this.context.search) {
            urlParams = getAllUrlParams(this.context.search);
        }
        let initialValues = Object.assign({}, urlParams, ReactFormHelpers.getInitialFormValues(this));
        initialValues = Object.assign(
            initialValues,
            ReactFormHelpers.getDefaultFormValues(this),
            this.filterFormValuesWithNullAsValue(ReactFormHelpers.getFormValues(this)),
            this.onOverrideGetFormValues()
        );

        const formDefinition = this.props.formDefinitions[this.state.currentForm];
        const regExp = "\{([^}]*)\}";      
        if (formDefinition !== undefined) {
            formDefinition.forEach((field) => {
                if (!!field.clearOnShowStep) {                                    
                    delete initialValues[field.name]; 
                }
                
                // delete empty tokens. e.g. '{FormField}
                let initialValue = initialValues[field.name];
                if(initialValue !== undefined && initialValue !== null){
                  let stringValue = initialValue.toString();
                  if (stringValue.match(regExp)){
                    delete initialValues[field.name];
                  }
                }
            });
        }
        return initialValues;
    }

    payload = {};
    setPayload = (payload: any) => {
        this.payload = {
            ...this.payload,
            ...payload
        };

        FormService.setPayload(this.payload);
    }
    getPayload = () => {
        return this.payload;
    } 

    onShowPollResults = () => {
        let formName = (this.props.formConfig as any).kenticoFormName || this.props.formName || "";

        if (!formName) {
            this.setState({
                isSubmitting: false 
            });
            return;
        }

        fetch(`/internal/formandcontentreact/PollResults/${formName}`)
            .then(response => {            
                if (response.status > 300) {
                    return { _error: true };
                } else {
                    return response.json();
                }
            })
            .then(json => {
                if (this.unmounted) {
                    return;
                }
        
                if (!json._error) {
                    this.setState({
                        isShowPollResults : true,
                        isSubmitting: false,
                        pollResults: json
                    });
                }
            })
            .catch(err => {
            // tslint:disable-next-line
                console.error(err);
            });            
    }

    render() {
        if (this.state.redirectToUrl !== undefined && this.state.redirectToUrl !== '') {
            return <Redirect to={this.state.redirectToUrl} />;
        }

        if (this.props.formDefinitions === undefined || this.props.formConfig === undefined) {
            return <></>;
        }
        
        if (this.state.stepIndex == this.props.formConfig.formSteps.length - 1) {
            this.wasOnSummaryStep = true;
        }        

        // Get initial values
        let initialValues = this.getInitialFormValues();

        if (this.state.urlParams !== undefined) {
            initialValues = (Object as any).assign(initialValues, this.state.urlParams);
            if (this.state.urlParams.broncode !== undefined) {
                delete initialValues['broncode'];
            }
        }

        initialValues = DefaultValueByConditionHelper.setInitialValues(this, initialValues);

        const preloadState = AnimationService.getAnimationStateForForm(this.state.currentForm);
        let formIsPreloadingCssClass = (preloadState == "start") ? "mijn-fnv__widget--preloading" : "";
        if (preloadState === "no-animations") {
            formIsPreloadingCssClass =  "mijn-fnv__widget--no-animations";
        }
        
        const formControllerProps = {
            additionalCssClass: `${this.props.additionalCssClass || ""} ${this.props.formName ? Slug.fromString(this.props.formName) : ""} ${formIsPreloadingCssClass}`,
            formCMSName: (this.props.formConfig as any).kenticoFormName || this.props.formName || "",
            initialValues: initialValues,
            formDefinitions: this.props.formDefinitions,
            onSubmit: this.onSubmit,
            onGotoPreviousStep: this.onGotoPreviousStep,
            formValues: this.props.forms,
            formConfig: this.props.formConfig,
            withLinkToFormPage: this.props.withLinkToFormPage,
            linkFormPage: this.props.nextLink,
            linkText: this.props.linkText,
            pageType: this.props.pageType,
            wasOnSummaryStep : this.wasOnSummaryStep,
            visitedSteps : this.visitedSteps,
            includeCurrentPageAsBackAndSubmitUrl: this.props.includeCurrentPageAsBackAndSubmitUrl,
            backTitleForCurrentPageBackLink: this.props.backTitleForCurrentPageBackLink,
            onFieldChange: this.props.onFieldChange,
            setFieldError: this.setFieldError,
            onSummaryBackToStepClick: this.onSummaryBackToStepClick,
            layoutType: this.props.layoutType
        };

        const popupText = {
            isUserError: this.state.isUserError,
            title:
                (this.state.isUserError && this.state.popupMessageOnFailure) ||
                this.props.errorMessageTitle ||                
                this.props.formConfig.popupHeadingOnFailure ||
                ErrorMessageService.errorMessageTitle(),
            message:
                this.state.popupMessageOnFailure ||
                this.props.errorMessageDescription ||
                this.props.formConfig.popupMessageOnFailure ||
                ErrorMessageService.errorMessageDescription(),
            explanation: '',
            telephoneHint: this.props.errorMessagePhoneNumberInfo || ErrorMessageService.errorMessagePhoneNumberInfo(),
            telephoneNumber: (this.props.errorMessagePhoneNumber || ErrorMessageService.errorMessagePhoneNumber() || "").replace(/ /g, ''),
            telephoneText: this.props.errorMessagePhoneNumber || ErrorMessageService.errorMessagePhoneNumber(),
            okButtonText: this.props.errorMessageButtonText || ErrorMessageService.errorMessageButtonText(),
            email: this.props.errorMessageEmail || "",
            emailInfo : this.props.errorMessageEmailInfo || "",
            linkUrl: this.props.formConfig.reactRouteOnFailure,
            container: this,
            stayOnPage: true // (!!this.props.formConfig.stayOnPageAfterErrorPopup)
        };

        const popupTooBigDataText = {
            ...popupText,
            title: this.props.formConfig.popupMessageOnTooBigDataFailure || getResourceString("Form.Popup.TooBigDataFailure") ||  
                    "Het verstuurde formulier bevat teveel data, verstuur minder grote bestanden of probeer het opnieuw.",
            stayOnPage: true,
            isUserError: true
        };

        const readonly = ReactFormHelpers.isReadOnly(this);
        this.setupOptionalBreadcrumbParent();

        // setting the below 'key' to a unique on each render
        // is needed to force recreating components, this is needed
        // in a deeper level for dropdowns .. so that in componentDidMount
        // the dropdown has the prefilled data AND the dropdown datasource data
        // (both are async processes on different points in the application, this helps
        // to get it in sync eventually)

        // key={uuidV4()}
        // a better way is to use the current Form name.. this forces
        // a rerender ONLY when the step/form changes and not on each rerender of
        // the FormContainer when the redux store changes for example

        // however.. an additional refreshId is needed which receives
        // a new id when this.props.forms changes (when data is prefilled for example)
        // this causes rerendering of underlaying components including dropdowns
        // fixing the above problem

        const renderFormController = (isPrintView : boolean) => <FormController
                ref={this.formControllerRef}
                key={this.state.currentForm + this.state.refreshId + (isPrintView ? "-print" : "-screen")}
                formContainer={this}
                isPrintView={isPrintView}
                formName={this.state.currentForm}
                stepIndex={this.state.stepIndex}
                readOnly={readonly}
                summaryIntro={this.props.summaryIntro}
                onSuccessPopupMessage={this.props.onSuccessPopupMessage}
                onSuccessPopupMessageVisualCheck={this.props.onSuccessPopupMessageVisualCheck}
                onSuccessPopupDescription={this.props.onSuccessPopupDescription}
                isSubmitting={this.state.isSubmitting}
                pageWithOnly1Step={this.props.formConfig.formSteps.length == 1}
                onSubmitSuccessButton1Link={this.props.onSubmitSuccessButton1Link}
                onSubmitSuccessButton1LinkText={this.props.onSubmitSuccessButton1LinkText}
                onSubmitSuccessButton2Link={this.props.onSubmitSuccessButton2Link}
                onSubmitSuccessButton2LinkText={this.props.onSubmitSuccessButton2LinkText}
                onStoreValues={this.onStoreValues}
                onCancelForm={this.onCancelForm}
                setFieldError={this.setFieldError}
                isSubmitStep={
                    this.props.formConfig.formSteps.length == 1 ||
                    this.state.stepIndex == this.props.formConfig.formSteps.length - 1
                }
                isSummaryStep={
                    this.state.stepIndex == this.props.formConfig.formSteps.length - 1
                }
                isShowPollResults={this.state.isShowPollResults}
                pollResults={this.state.pollResults}
                {...formControllerProps}
                steps={this.props.steps && this.props.steps.steps ? this.props.steps.steps : undefined}
                renderFormError={() => {
                    return (!this.props.formConfig.hideAlertsOnFormLevel && 
                            this.props.forms[this.state.currentForm + '_ERROR'] || '') !==
                        '' ? (
                        <AlertMessage
                            title={this.props.forms[this.state.currentForm + '_ERROR']}
                            type="form-error-block"
                            link=""
                            linkText=""
                        ></AlertMessage>
                    ) : null;
                }}
                renderCustomField={(formFieldDefinition: any, formController: any, formikBag: any) => {
                    Logger.debug(`Rendering custom field: ${formFieldDefinition.customType}`);

                    return (
                        <React.Fragment key="renderCustomField">
                          {
                            {
                              // simulate 'switch/case'
                              'contributie': <Templates.Contributie
                                  formFieldDefinition={formFieldDefinition}
                                  formikBag={formikBag}
                                  formName={this.state.currentForm} 
                                  payload={this.getPayload()}                                    
                                  forms={this.props.forms} 
                              />,
                              'richtextcontent': <Templates.RichtTextContent formFieldDefinition={formFieldDefinition}
                                    formConfig={this.props.formConfig}
                                    formController={formController}
                                    formikBag={formikBag}
                                    formName={this.state.currentForm} 
                                    payload={this.getPayload()}
                                    formDefinitions={this.props.formDefinitions}                                   
                                />,
                                'ctablock': <Templates.CTABlock formFieldDefinition={formFieldDefinition} 
                                />,
                                'tip': <Templates.Tip formFieldDefinition={formFieldDefinition} />,
                                'alert': <Templates.Alert formFieldDefinition={formFieldDefinition} />,
                                'titleHeadingTwo': <Templates.TitleHeadingTwo formFieldDefinition={formFieldDefinition} />,
                                'link': <Templates.InternalLink
                                    initialValues={initialValues}
                                    formFieldDefinition={formFieldDefinition}
                                />,
                                'simpleText': <Templates.SimpleText
                                    formFieldDefinition={formFieldDefinition}
                                />,
                                'petitieTeller': <Templates.PetitieTeller
                                    initialValues={initialValues}
                                    formFieldDefinition={formFieldDefinition}
                                />,
                                'popupConfirm': (this.state.showPopupConfirm && <Templates.PopupConfirm
                                    onOK={this.onPopupConfirmOK}
                                    onCancel={this.onPopupConfirmCancel}
                                    formFieldDefinition={formFieldDefinition}
                                />),
                                'popupOk': (this.state.showPopupOK && <Templates.PopupOK
                                    onOK={this.onPopupOKSubmit}
                                    formFieldDefinition={formFieldDefinition}
                                />),
                                'grid': <Templates.Grid
                                    formFieldDefinition={formFieldDefinition}
                                    form={
                                        formFieldDefinition.form !== undefined
                                            ? this.props.forms[formFieldDefinition.form]
                                            : this.props.forms[this.state.currentForm]
                                    }
                                />,
                                'list': <Templates.List
                                    items={this.props.forms[!!formFieldDefinition.form ? formFieldDefinition.form : this.state.currentForm]?.[formFieldDefinition.name]}
                                    name={formFieldDefinition.name}
                                    noDataText={formFieldDefinition.noDataText}
                                    columns={formFieldDefinition.columns}
                                  />,
                                'horizontal-ruler':  <Templates.HorizontalRuler
                                    formFieldDefinition={formFieldDefinition}
                                />,
                                'loginRedirect': <Templates.LoginRedirect
                                    formFieldDefinition={formFieldDefinition}
                                />,
                                'summary': <Templates.Summary
                                    forms={this.props.forms}
                                    formDefinitions={this.props.formDefinitions}
                                    onClick={this.onSummaryBackToStepClick}
                                    formFieldDefinition={formFieldDefinition}
                                    formContainer={this}
                                />,
                              }[formFieldDefinition.customType]
                            }
                        </React.Fragment>
                    );
                }}
            />;
        return (
            <React.Fragment>
                {this.props.formConfig.showPrintButton &&
                ((this.state.isShowPostOk && !this.state.showThanksMessageAsInPageContent) ||
                 !this.state.isShowPostOk) &&
                 this.state.stepIndex == this.props.formConfig.formSteps.length - 1 && 
                 this.props.formConfig.formSteps.length > 1 &&
                    renderFormController(true)}
                {((this.state.isShowPostOk && !this.state.showThanksMessageAsInPageContent) ||
                 !this.state.isShowPostOk) && renderFormController(false)}
                {this.state.isShowPostDataError ? <PopupError {...popupText} /> : null}
                {this.state.isShowTooBigDataError ? <PopupError {...popupTooBigDataText} /> : null}
                {this.state.isShowPostOk && !this.state.showThanksMessageAsInPageContent ? (
                    <PopupOk
                        onPopupOK={this.onPopupOKSubmit}
                        okButtonText="OK"
                        withIcon={this.state.isShowPostOKWithVisualCheck ? "icon-clock" : undefined}
                        message={this.state.isShowPostOKWithVisualCheck ? 
                            this.props.onSuccessPopupMessageVisualCheck || getResourceString("Form.Popup.VisualCheck") || "Aanpassingen zijn verstuurd. Het kan enige tijd duren dat dit is verwerkt." : 
                            this.props.onSuccessPopupMessage || getResourceString("Form.Popup.SuccessfullySend") || 'Succesvol verstuurd'
                        }
                        description={this.props.onSuccessPopupDescription}
                    />
                ) : null}
                {this.state.isShowPostOk && !!this.state.showThanksMessageAsInPageContent ? (
                    <div ref={this.thankYouMessageRef} className="form form__thanks-message-in-page">{ReactHtmlParser(this.props.onSuccessPopupMessage) || 'Succesvol verstuurd'}</div>
                ) : null}
            </React.Fragment>
        );
    }

    static contextType = MijnFNVPageContext;
    context!: React.ContextType<typeof MijnFNVPageContext>;
}

//FormControllerContainer.contextType = MijnFNVPageContext;

export const FormContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(FormControllerContainer);
